"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WaypointTimeline = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseTimeline = require("nicbase-timeline");

var _nicbaseTooltip = _interopRequireDefault(require("nicbase-tooltip"));

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../constants");

var _tooltipContent = _interopRequireDefault(require("./tooltip/tooltip-content"));

var _deviationBadge = _interopRequireDefault(require("./deviation-badge"));

var _waypointTimelineDetails = _interopRequireDefault(require("./waypoint-timeline-details"));

require("./waypoint-timeline.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var WaypointTimeline = function WaypointTimeline(_ref) {
  var assetType = _ref.assetType,
      waypoints = _ref.waypoints,
      status = _ref.status,
      realStartTime = _ref.realStartTime,
      latestData = _ref.latestData;

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.informationLists;
  }),
      pois = _useSelector.pois;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      detailsOpen = _useState2[0],
      setDetailsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)({
    poiTerm: '',
    address: {},
    poiCategory: {},
    radius: null,
    geometry: null
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      waypointDetail = _useState4[0],
      setWayPointDetail = _useState4[1];

  var isTourRunning = status === _constants.TOUR_STATUS.RUNNING;
  var offlineLimit = (0, _mapping.isRailAsset)(assetType) ? _constants.ASSET_OFFLINE_LIMIT_RAIL : _constants.ASSET_OFFLINE_LIMIT;
  var isDataCurrent = !(latestData !== null && latestData !== void 0 && latestData.common.date) ? Date.now() - new Date(realStartTime).getTime() < offlineLimit : Date.now() - new Date(latestData.common.date).getTime() < offlineLimit;

  var calculateDeviation = function calculateDeviation(realArrival, scheduledOrPlannedTime) {
    var arrivalDate = new Date(realArrival);
    arrivalDate.setSeconds(0);
    arrivalDate.setMilliseconds(0);
    var scheduledDate = new Date(scheduledOrPlannedTime);
    scheduledDate.setSeconds(0);
    scheduledDate.setMilliseconds(0);
    return (arrivalDate.getTime() - scheduledDate.getTime()) / 60000;
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseTimeline.Timeline, {
    className: "max-w-112"
  }, waypoints.map(function (waypoint, index) {
    var _latestData$pois;

    var estimatedTimeOfArrival = waypoint.estimatedTimeOfArrival,
        scheduledTimeOfArrival = waypoint.scheduledTimeOfArrival,
        plannedStartTime = waypoint.plannedStartTime,
        realTimeOfArrival = waypoint.realTimeOfArrival,
        realTimeOfDeparture = waypoint.realTimeOfDeparture,
        poiId = waypoint.poiId,
        poiName = waypoint.poiName,
        id = waypoint.id,
        frontendId = waypoint.frontendId,
        earlyTolerance = waypoint.earlyTolerance,
        lateTolerance = waypoint.lateTolerance,
        type = waypoint.type,
        address = waypoint.address,
        radius = waypoint.radius,
        geometry = waypoint.geometry;
    var poi = pois.find(function (p) {
      return p.id === poiId;
    }); // find poi term name for current waypoint

    var poiTerm = poi ? poi.name : poiName; // make a list of poiTerm ids from latest data, and see if the waypoint is in the list

    var isAssetInPOI = type === _constants.WAYPOINT_TYPES.START && (latestData === null || latestData === void 0 ? void 0 : (_latestData$pois = latestData.pois) === null || _latestData$pois === void 0 ? void 0 : _latestData$pois.map(function (poiObject) {
      return poiObject.id;
    }).includes(poiId)); // determine if the waypoint has already been reached

    var isArrived = realTimeOfArrival || realTimeOfDeparture || isAssetInPOI;
    var deviation; // calculate deviation (for badge) for waypoint depending on whether it is a future or already reached stop

    var realArrival = realTimeOfArrival;
    var usingETA = false;

    if (!realArrival && estimatedTimeOfArrival) {
      realArrival = estimatedTimeOfArrival;
      usingETA = true;
    }

    if (realArrival && scheduledTimeOfArrival) {
      deviation = calculateDeviation(realArrival, scheduledTimeOfArrival);
    }

    realArrival = realTimeOfDeparture || realArrival;

    if (realArrival && plannedStartTime) {
      deviation = calculateDeviation(realArrival, plannedStartTime);
    }

    var leftBadge = null; // if we are using an ETA but the data is no longer current, report that the asset is offline

    if (usingETA && isTourRunning && !isDataCurrent) {
      leftBadge = /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.assetOffline"
      }, function (text) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "asset-offline"
        }, text);
      });
    }

    if (leftBadge === null) {
      leftBadge = /*#__PURE__*/_react["default"].createElement(_deviationBadge["default"], {
        minutes: deviation,
        earlyTolerance: earlyTolerance,
        lateTolerance: lateTolerance
      });
    }

    var _ref2 = address !== null && address !== void 0 ? address : {},
        countryCode = _ref2.countryCode,
        street = _ref2.street,
        postalCode = _ref2.postalCode,
        city = _ref2.city;

    var addressCondition = street || postalCode || city;
    return /*#__PURE__*/_react["default"].createElement(_nicbaseTimeline.TimelineItem, {
      key: id || frontendId,
      className: (0, _classnames["default"])('waypoint', {
        isReached: isArrived
      }),
      lineBeforeClassName: (0, _classnames["default"])('progress-line', {
        isArrived: isArrived
      }),
      lineAfterClassName: (0, _classnames["default"])('progress-line', {
        isDeparted: realTimeOfDeparture
      }),
      left: leftBadge,
      dot: /*#__PURE__*/_react["default"].createElement("div", {
        className: "waypoint__dot",
        "data-for": waypoint.id,
        "data-tip": ""
      }, index + 1, /*#__PURE__*/_react["default"].createElement(_nicbaseTooltip["default"], {
        id: waypoint.id,
        place: "right",
        data: /*#__PURE__*/_react["default"].createElement(_tooltipContent["default"], {
          waypoint: _objectSpread(_objectSpread({}, waypoint), {}, {
            name: poiTerm,
            type: pois.find(function (p) {
              return p.id === poiId;
            }) ? pois.find(function (p) {
              return p.id === poiId;
            }).category.icon : 'default'
          })
        })
      })),
      right: /*#__PURE__*/_react["default"].createElement("span", {
        "data-for": waypoint.id,
        "data-tip": "",
        onClick: function onClick() {
          setDetailsOpen(true);
          setWayPointDetail({
            poiTerm: poiTerm,
            address: address,
            poiCategory: poi === null || poi === void 0 ? void 0 : poi.category,
            radius: radius,
            geometry: geometry
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "font-bold text-sm"
      }, poiTerm), addressCondition && /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex flex-col text-sm"
      }, /*#__PURE__*/_react["default"].createElement("span", null, street), /*#__PURE__*/_react["default"].createElement("span", null, countryCode && postalCode ? "".concat(countryCode, "-").concat(postalCode) : postalCode, " ", city)))
    });
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.DetailDialog, {
    title: "Details",
    content: /*#__PURE__*/_react["default"].createElement(_waypointTimelineDetails["default"], {
      poiTerm: waypointDetail.poiTerm,
      poiCategory: waypointDetail.poiCategory,
      address: waypointDetail.address,
      radius: waypointDetail.radius,
      geometry: waypointDetail.geometry
    }),
    confirmText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.close",
      tagName: "span"
    }),
    active: detailsOpen,
    onCloseDialog: function onCloseDialog() {
      setDetailsOpen(false);
    }
  }));
};

exports.WaypointTimeline = WaypointTimeline;
WaypointTimeline.propTypes = {
  assetType: _propTypes["default"].number,
  waypoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    estimatedTimeOfArrival: _propTypes["default"].string,
    scheduledTimeOfArrival: _propTypes["default"].string,
    plannedStartTime: _propTypes["default"].string,
    realTimeOfArrival: _propTypes["default"].string,
    realTimeOfDeparture: _propTypes["default"].string,
    poiId: _propTypes["default"].number,
    id: _propTypes["default"].string
  })),
  status: _propTypes["default"].string.isRequired,
  realStartTime: _propTypes["default"].string,
  latestData: _propTypes["default"].shape({
    common: _propTypes["default"].shape({
      date: _propTypes["default"].string
    }),
    pois: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  })
};
WaypointTimeline.defaultProps = {
  assetType: null,
  waypoints: [],
  realStartTime: null,
  latestData: null
};
var _default = WaypointTimeline;
exports["default"] = _default;